module.exports = __webpack_public_path__ + "static/media/ASH Virtual Presentation Tips Video_ Outline _1612007254486.4836e96d.docx";